import Helper from '../helpers/Helper';
import ResizeObserver from 'resize-observer-polyfill';

export default class PageHeader {
    constructor() {
        this.el = null;
    }
    init(el) {
        if (el === undefined || el === null) {
            return;
        }
        this.el = el;
        this.bind();
        this.setupResizeObserver();
        this.menuAccessible();
    }
    bind() {
        let selector = 'page-header',
            curPos = this.scrollTop(),
            lastPos = curPos,
            throttle = 250,
            isHidden = false,
            container = Helper.isInsideEditor() ? document.querySelector('.page-wrap') : window,
            onTop = true;
        this.dynamicallySetHeaderDimensions();
        container.addEventListener('scroll', () => {
            if (document.querySelector('.' + selector) === null) {
                return;
            }
            curPos = this.scrollTop();
            if (curPos > throttle && onTop === true) {
                document.querySelector('.' + selector).classList.add(selector + '--scrolled');
                this.dynamicallySetHeaderDimensions();
                onTop = false;
            }
            if (curPos <= throttle && onTop === false) {
                document.querySelector('.' + selector).classList.remove(selector + '--scrolled');
                this.dynamicallySetHeaderDimensions();
                onTop = true;
            }
            if (curPos < lastPos && isHidden === true) {
                isHidden = false;
                document.querySelector('.' + selector).classList.remove(selector + '--hidden');
                if (document.querySelector('.header-stamp') !== null) {
                    document
                        .querySelector('.header-stamp')
                        .classList.remove('header-stamp--hidden');
                }
            }
            if (
                curPos > 0 &&
                curPos > lastPos &&
                Math.abs(curPos - lastPos) > throttle &&
                isHidden === false &&
                document.querySelector('.' + selector).querySelector('.mainmenu__state').checked ===
                    false
            ) {
                isHidden = true;
                document.querySelector('.' + selector).classList.add(selector + '--hidden');
                if (document.querySelector('.header-stamp') !== null) {
                    document.querySelector('.header-stamp').classList.add('header-stamp--hidden');
                }
            }
            if (curPos < lastPos || curPos > throttle + lastPos) {
                lastPos = curPos;
            }
        });
    }
    scrollTop() {
        if (Helper.isInsideEditor()) {
            return document.querySelector('.page-wrap').scrollTop;
        } else {
            return window.pageYOffset || document.documentElement.scrollTop;
        }
    }
    setupResizeObserver() {
        const observer = new ResizeObserver(() => {
            this.dynamicallySetHeaderDimensions();
        });
        if (document.querySelector('.page-header') !== null) {
            observer.observe(document.querySelector('.page-header'));
            observer.observe(document.querySelector('.mainmenu'));
            observer.observe(document.querySelector('.logo__link, .logo > a'));
        }
    }
    dynamicallySetHeaderDimensions() {
        let pageHeader = document.querySelector('.page-header'),
            pageWrap = document.querySelector('.page-wrap'),
            mainMenu = document.querySelector('.mainmenu'),
            menuHeaderInner = document.querySelector('.menu-header-inner'),
            menuHeader = document.querySelector('.menu-header'),
            logoContainer = document.querySelector('.logo__link, .logo > a'),
            stampContainer = document.querySelector('.header-stamp'),
            logo = document.querySelector('.logo__image')
                ? document.querySelector('.logo__image')
                : document.querySelector('.logo__text'),
            logoIsImage = document.querySelector('.logo__image') !== null,
            padding = 20,
            breakpointLG = 1349,
            breakpointSM = 768,
            menuBarHeight = 0,
            logoContainerHeight,
            stampContainerHeight,
            headerHeight,
            logoRatio = logo === null ? 1 : Math.floor(logo.clientWidth / logo.clientHeight),
            logoContainerHeightBig = 130,
            logoContainerHeightMedium = 80,
            logoContainerHeightSmall = 50,
            stampPaddingNone = 0,
            stampPaddingBig = 45;

        if (pageHeader === null) {
            return;
        }
        if (pageHeader.clientWidth > breakpointLG) {
            // special treatment of long logos
            if (
                (menuHeader.classList.contains('menu-header--layout-3') ||
                    menuHeader.classList.contains('menu-header--layout-4')) &&
                logoIsImage &&
                logoRatio >= 5
            ) {
                logoContainerHeightBig = logoContainerHeightBig - 5 * logoRatio;
                logoContainerHeightMedium = logoContainerHeightMedium - 3.5 * logoRatio;
            }
            if (
                menuHeader.classList.contains('menu-header--layout-1') ||
                menuHeader.classList.contains('menu-header--layout-2') ||
                pageHeader.classList.contains('page-header--scrolled')
            ) {
                logoContainerHeight = logoContainerHeightMedium;
                stampContainerHeight = stampPaddingNone;
            } else if (
                menuHeader.classList.contains('menu-header--layout-3') ||
                menuHeader.classList.contains('menu-header--layout-4')
            ) {
                logoContainerHeight = logoContainerHeightBig;

                if (document.querySelector('.header-stamp') !== null) {
                    stampContainerHeight = stampPaddingBig;
                }
            }
            logoContainer.style.height = logoContainerHeight + 'px';
            if (document.querySelector('.header-stamp') !== null) {
                stampContainer.style.marginTop = stampContainerHeight + 'px';
            }
            if (mainMenu.clientWidth + logo.clientWidth > menuHeaderInner.clientWidth) {
                menuBarHeight = mainMenu.clientHeight;
            }
        }
        if (pageHeader.clientWidth > breakpointSM && pageHeader.clientWidth <= breakpointLG) {
            logoContainerHeight = logoContainerHeightMedium;
            logoContainer.style.height = logoContainerHeight + 'px';

            if (document.querySelector('.header-stamp') !== null) {
                stampContainer.style.paddingTop = 0;
            }
        }
        if (breakpointSM >= pageHeader.clientWidth) {
            logoContainerHeight = logoContainerHeightSmall;
            logoContainer.style.height = logoContainerHeight + 'px';

            if (document.querySelector('.header-stamp') !== null) {
                stampContainer.style.paddingTop = 0;
            }
        }
        headerHeight = padding + logoContainerHeight + menuBarHeight;
        pageHeader.style.height = headerHeight + 'px';
        pageWrap.style.paddingTop = headerHeight + 'px';
        localStorage.setItem(
            'preloadDimensions',
            JSON.stringify([headerHeight, logoContainerHeight])
        );
    }

    // menu accessibility

    updateAriaExpanded() {
        let input = document.getElementById('mainmenu__state');
        if (input) {
            let expanded = input.getAttribute('aria-expanded');
            if (expanded == 'true' || expanded == true) {
                input.setAttribute('aria-expanded', false);
            } else {
                input.setAttribute('aria-expanded', true);
            }
        }
    }
    listenerFocusOut() {
        let input = document.getElementById('mainmenu__state');
        if (input) {
            input.checked = false;
            this.updateAriaExpanded();
        }
    }
    menuAccessible() {
        let menuToggle = document.querySelector('.mainmenu'),
            input = document.getElementById('mainmenu__state'),
            subMenuItems = menuToggle.querySelectorAll('.mainmenu__link');
        if (input) {
            input.addEventListener('keyup', (event) => {
                if (event.key === 'Enter') {
                    if (input.classList.contains('is-focus-visible')) {
                        input.checked = !input.checked;
                        this.updateAriaExpanded();
                    }
                }
            });
            input.addEventListener('focus', () => {
                if (menuToggle) {
                    if (!menuToggle.classList.contains('is-focus-visible')) {
                        menuToggle.classList.add('is-focus-visible');
                    }
                }
            });
            input.addEventListener('focusout', () => {
                if (menuToggle) {
                    if (menuToggle.classList.contains('is-focus-visible')) {
                        menuToggle.classList.remove('is-focus-visible');
                    }
                }
            });
            input.addEventListener('click', () => {
                if (menuToggle) {
                    if (menuToggle.classList.contains('is-focus-visible')) {
                        menuToggle.classList.remove('is-focus-visible');
                    }
                }
                this.updateAriaExpanded();
            });
            input.addEventListener('keydown', (e) => {
                if (e.shiftKey && e.keyCode == 9) {
                    if (input.classList.contains('is-focus-visible')) {
                        input.checked = false;
                        this.updateAriaExpanded();
                    }
                }
            });
        }

        if (subMenuItems.length > 0) {
            subMenuItems[subMenuItems.length - 1].addEventListener(
                'focusout',
                this.listenerFocusOut.bind(this)
            );
        }
    }
}
